module.exports = __webpack_public_path__ + "static/img/user.e41abfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user.png
// module id = AGL3
// module chunks = 33